import { render } from "./App.vue?vue&type=template&id=1fea4ebe"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=1fea4ebe&lang=css"

import exportComponent from "C:\\Users\\perez\\Proyectos\\Vue\\04-pokemon-game\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__